export const initConfig = (app: "main" | "website" = "main") => {
	const env = import.meta.env;

	window.$config = {
		successCode: env.VITE_SUCCESS_CODE ? Number(env.VITE_SUCCESS_CODE) : 0,
	};

	window.__APP__ = app;
};
